<template>



  <div class="home">


            <b-jumbotron header="Profil Turfiste"
                     lead="Découvrez votre profil turfiste et les stratégies de jeux faites pour vous"
        >
          <p>Grace à ce court questionnaire, qui ne vous demandera que 80 secondes de votre temps, nous vous fournirons un profil personnalisé de votre jeu et vous proposerons les stratégies de jeux qui vous sont les plus adaptées. Répondez aux 10 questions suivantes.</p>
          <p><i>Ce service vous est offert par le groupe Turfmedia, société d'éditions turf.</i></p>

          <b-button variant="primary" to="/section1">Commencer</b-button>
        </b-jumbotron>



  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',

}
</script>